import React, { Component } from 'react';
import { BrowserRouter, Route,  Navigate, Link } from 'react-router-dom'
import { ProgressSpinner } from 'primereact/progressspinner';
import Header from '../Header.js'
import LoginBox from "./../LoginBox.js";
import { Dialog } from "primereact/dialog";
import { connect } from "react-redux"
import Server from '../Server.js'
import { Button, Popover } from 'antd';
import { Dropdown } from 'primereact/dropdown';

class Vam extends React.Component {     
  constructor(props){
    super(props);
    this.state={ 
      
    }
    var navigation = this.props.navigation
   
    this.Server = new Server();
    this.state = {
      basic: true,
      listViewData: [],
      Accounts:[],
      ShowLoading:false,
      AccList:[]
    };

  }
  componentDidMount(){
    if(this.props.username)
      this.GetAccounts();
    else
      this.setState({
        showLogin: true
      })
  }
  GetMyAccounts(selectedVamNumber) {
    let that = this;

    let SCallBack = function (response) {

        let data = [];
        let resp = [];
        for (let i = 0; i < response.length; i++) {
            resp[i] = response[i].children;

        }
        for (let i = 0; i < resp.length; i++) {
            for (let j = 0; j < resp[i].length; j++) {
                if (resp[i][j].name == "A_Kind") {
                    if (resp[i][j].value == "5")
                        data.push(resp[i])
                }
                

            }
        }
        let AccList = [];
        for (let i = 0; i < data.length; i++) {
            AccList[i] = { value: data[i][1].value, label: data[i][3].value + "(" + data[i][1].value + ") موجودی: "+data[i][2].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+" ریال" }
        }
        that.setState({
            AccList: AccList,
            Account: AccList.length > 1 ? null : AccList[0].value,
            ShowLoading: false,
            AccDialog: true,
            selectedVamNumber: selectedVamNumber
        })
        that.getUser(1);

    }
    let ECallBack = function (error) {
        that.setState({
            ShowLoading: false
        })
    }

    var param = '{CommandNo : "3" , AccountNo: "' + that.props.account + '",Param1: "' + that.props.password + '" }';
    let ip = that.props.ip || "https://ansar24.com";
    that.setState({
        ShowLoading: true
    })
    that.Server.sendRaymand("" + ip + "/MobileBank.aspx/MobileBankSp", param, SCallBack, ECallBack,{
        ip: that.props.ip
    })
}
  ConvertNumToFarsi(text){
    if(!text)
      return text;
    var id= ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
    return text.toString().replace(/[0-9]/g, function(w){
     return id[+w]
    });
  }
  GetAccounts(RefreshVam){
   
    let that = this;
    this.setState({
      ShowLoading: true
    })
    let SCallBack = function(response){
      let data=[];
      let resp=[];    
     for(let i=0;i<response.length;i++){
       resp[i] = response[i].children;
      
     }
     for(let i=0;i<resp.length;i++){
      for(let j=0;j<resp[i].length;j++){

        if(resp[i][j].name=="A_Kind"){
         
          if(resp[i][j].value=="6"){ 
            data.push(resp[i])   
          }
          
        }

      }        
     }
     let ListView=[];               
     let count = 0;
     for(let i=0;i<data.length;i++){
     let price = that.Price(data[i][2].value);
     if(data[i][2].value !="0"){
        count++; 
        let color = count%2 ? '#ebdd25' : '#6ca0ff'

        ListView[count] = { 
          data : 
          <div className="sarv-card-background" style={{ background: '#fff', borderRadius: 0, height: 190, position: 'relative',borderRadius:7 }}>
              <div className="sarv-svg-wave-container" style={{borderRadius:7}} >

                <svg viewBox="0 0 360 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M176.953 42.4793C97.8294 29.9611 14.0245 37.2634 -18 42.4793V7.53268C-18 2.94268 -12.1364 0.751991 -9.20455 0.230398C112.128 0.0565343 356.145 -0.186875 361.558 0.230398C366.97 0.647671 368.775 5.27245 369 7.53268V40.9145C337.878 46.652 255.877 54.9975 176.953 42.4793Z" fill="url(#paint0_linear_76_93)" />
                  <defs>
                    <linearGradient id="paint0_linear_76_93" x1="175.5" y1="49" x2="175.5" y2="-3.19501e-06" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#A78458" />
                      <stop stop-color="#993F3F" />
                      <stop stop-color="#993F3F" />
                      <stop stop-color="#993F3F" />
                      <stop stop-color="#993F3F" />
                      <stop stop-color="#CE6D6D" />
                      <stop offset="0.0001" stop-color="#A78458" />
                      <stop offset="0.466667" stop-color="#FFB970" stop-opacity="0.54" />
                      <stop offset="0.604167" stop-color="#EBAD6A" stop-opacity="0.645117" />
                      <stop offset="1" stop-color="#A78458" />
                    </linearGradient>
                  </defs>
                </svg>


              </div>
              <div style={{ position: 'absolute', top: 0, right: 0, width: '100%' }}>
                <span style={{ color: '#000', display: 'list-item', direction: 'rtl', listStyle: 'inside', marginRight: 50, marginTop: 10, textAlign: 'right' }}> {data[i][3].value} ({that.ConvertNumToFarsi(data[i][1].value)})</span>
                <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', marginTop: 30 }} >

                </div>
                <div style={{  display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <div style={{width:'100%'}}>

                    <div style={{ padding: "8px 0px", display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', justifyContent: 'space-between', alignContent: 'flex-start' }} >
                      <div>
                        <span style={{ color: '#fff',background:'#C0111A', fontSize: 18, display: 'flex',borderRadius: "0px 21px 21px 0px",padding:'5px 15px 5px 15px' }} className="iranyekanwebmedium" >
                          <span  className="iranyekanwebmedium" style={{paddingRight:5}}>ریال</span><span>{that.ConvertNumToFarsi(price)} </span>
                        </span>

                      </div>
                    </div>

                    <div style={{display: 'flex',width:'100%', flexWrap: 'nowrap', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'flex-start',marginTop:15 }}>
                      <div>
                      <Popover
                        content={<div style={{display:'flex',justifyContent:'space-around',flexDirection:'column',height:90}}>
                          <Button  style={{textAlign:'right'}} onClick={()=>{
                            window.open("https://r-bank.ir/"+that.props.place+data[i][1].value,"_blank")
                          }}>از حساب بانکی</Button>
                          <Button danger style={{textAlign:'right'}} onClick={()=>{
                            that.GetMyAccounts(data[i][1].value)
                          }}>از حساب داخلی</Button>
                        </div>}
                        trigger="click"
                        open={that.state.OpenPopover}
                        onOpenChange={(event)=>{
                          that.setState({
                            OpenPopover: event
                          })
                        }}
                      >
                        <div style={{borderRadius:5,padding:5}} className="p-button p-component iranyekanwebmedium" ><span style={{ fontFamily: 'iranyekanwebmedium', fontSize: 15 }}  onClick={()=>{
                              //window.open("https://r-bank.ir/"+that.props.place+data[i][1].value,"_blank")
                              that.setState({
                                      payVamModal: true
                                  })
                        }}><span name="refresh" style={{ fontSize: 15, color: '#768883' }} /> پرداخت</span></div>
                      </Popover>
                      </div>
                      <div >
                        <div >
                          <Link to={`${process.env.PUBLIC_URL}/Gardesh?VamType=1&account=`+data[i][1].value} className="p-button p-component iranyekanwebmedium " style={{ textDecoration: 'none',borderRadius:5,padding:5 }}>
                            <span style={{ fontFamily: 'iranyekanwebmedium', fontSize: 15 }} ><span name="pulse" style={{ fontSize: 16 }} />  پرداخت شده</span>
                          </Link>
                        </div>
                      </div>
                      <div >
                      <Link to={`${process.env.PUBLIC_URL}/Gardesh?VamType=2&account=`+data[i][1].value} className="p-button p-component iranyekanwebmedium " style={{ textDecoration: 'none',borderRadius:5,padding:5 }}>
                            <span style={{ fontFamily: 'iranyekanwebmedium', fontSize: 15 }} ><span name="pulse" style={{ fontSize: 16 }} />   باقیمانده</span>
                          </Link>
                        
                         
                      </div>
                    </div>
                    
                  </div>

                </div>
              </div>
            </div>


        }
      }
     }
     that.setState({
      listViewData: ListView,
      ShowLoading:0
     })
    
    } 
    let ECallBack = function(error){
    }
    
    var param = '{CommandNo : "3" , AccountNo: "' + that.props.account + '",Param1: "' + that.props.password + '" }';
    let ip = that.props.ip || "https://ansar24.com";

    that.Server.sendRaymand(""+ip+"/MobileBank.aspx/MobileBankSp",param,SCallBack,ECallBack,{
      ip: that.props.ip
  })
  }
  Price(num){
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  render() {
    if(this.state.GoToLocalPayment){
      return <Navigate to={"/Transfer?Type=LocalTransfer&selectedVamNumber="+this.state.selectedVamNumber+"&account="+this.state.Account} />;
    }
    return (
      !this.state.ShowLoading ?
      <div style={{height:'100%'}} >
        <Dialog
            header="ورود به سامانه"
            visible={this.state.showLogin}
            maximized={true}
            closable={true}
            resizable={false}
            draggable={false}
            onHide={() => {
              if (this.props.username) {
                this.setState({
                  showLogin: false,
                });
                this.GetAccounts();
              } else {
                window.history.back();
              }
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                
                flexDirection: "column",
              }}
            >
              <LoginBox
                appData={this.props.appData}
                loginBank={true}
                AfterLogin={(variables) => {
                  this.setState({
                    showLogin: false,
                  });
                  this.GetAccounts();
                }}
              />
            </div>
          </Dialog>
      <Header ComponentName="تسهیلات" />
      <div style={{display:'flex',height:'100%',justifyContent:'space-between'}} className="sarv-bg1 sarv-home-top-box" >


          <div style={{position:'relative',width:'100%',textAlign:'left',marginTop:30}}>
          {
            this.state.listViewData.map((item, index) => (
              <div key={index} style={{margin:10}}>
                {item.data}
              </div>     
            )) 
          }
          </div>
        </div>
         <Dialog header="" visible={this.state.AccDialog} maximized={true} onHide={() => {
                    this.setState({
                        AccDialog: false
                    });
                }
                }>

                    {!this.state.ShowLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60%', flexDirection: 'column',direction:'rtl' }} >
                           
                           <div className="iranyekanwebmedium" style={{ height: '50px' }}></div>
                            {this.state.AccList.length > 1 &&
                                <Dropdown style={{ width: '90%', textAlign: 'right' }} value={this.state.Account} options={this.state.AccList} onChange={(e) => this.setState({ Account: e.value })} placeholder="حساب خود را انتخاب کنید" />
                            }
                            {this.state.Account &&
                                <div className="iranyekanwebmedium" style={{ marginTop: 20 }}>
                                    برداشت از حساب : {this.state.Account}
                                </div>
                            }
                            <div style={{ width: '100%', textAlign: 'right', marginTop: 50, display: 'flex', justifyContent: 'center' }}>
                                <Button className="iranyekanwebmedium" disabled={!this.state.Account} onClick={()=>{
                                  this.setState({
                                    GoToLocalPayment: true
                                  })
                                }} style={{ textAlign: 'center', borderRadius: 15, width: '80%' }}> <span className="iranyekanwebmedium" style={{ width: '100%' }} >ادامه </span> </Button>

                            </div>
                        </div>
                        :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
                        </div>
                    }

                </Dialog>
        </div>

        :
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
          <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s"/>
            
          </div>  
      
          
        
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place:state.place,
    fullname : state.fullname,
    tokenrb: state.tokenrb,
    mobile : state.mobile,
    Theme : state.Theme,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(Vam)  
